// extracted by mini-css-extract-plugin
export default {"header":"Header_header__nOZ0+","left":"Header_left__Ams0B","title":"Header_title__KNvi3"};